<template>
  <div class="container">
    <div class="container_box">
      <!-- 顶部操作栏 -->
      <header class="header">
        <!-- <button class="history-btn" @click="toggleHistory"> -->
        <div class="header_box" @click="toggleHistory">
          <img src="@/assets/images/histo01.png" alt="" />
          <div class="header_box_text">
            {{ showHistory ? "关闭历史" : "历史记录" }}
          </div>
        </div>

        <!-- </button> -->
      </header>

      <template v-if="showHistory">
        <!-- 聊天消息区域 -->
        <main
          class="chat-area show-history"
          :class="loading ? 'show-history-loading' : ''"
        >
          <div
            v-for="(msg, index) in chatHistory"
            :key="index"
            :class="['message', `${msg.type}-message`]"
          >
            <!-- <div class="timestamp">{{ formatTime(msg.timestamp) }}</div> -->

            <div v-if="msg.type === 'ai'" class="avateAi">
              <img src="@/assets/images/avateAi.png" alt="AI头像" />
            </div>
            <div v-else-if="msg.type === 'user'" class="userAvate">
              <img src="@/assets/images/userAvate.png" alt="用户头像" />
            </div>

            <div
              v-if="msg.content"
              v-html="msg.content"
              :class="['bubble', `${msg.type}-bubble`]"
            ></div>
            <div v-show="msg.type === 'time'" class="timestamp">
              {{ msg.timestamp }}
            </div>
          </div>
        </main>
      </template>

      <template v-else>
        <main class="chat-area">
          <div
            v-for="(msg, index) in chatList"
            :key="index"
            :class="[
              'message',
              msg.type === 'ai' ? 'ai-message' : 'user-message',
            ]"
          >
            <div v-if="msg.type === 'ai'" class="avateAi">
              <img src="@/assets/images/avateAi.png" alt="AI头像" />
            </div>
            <div v-else-if="msg.type === 'user'" class="userAvate">
              <img src="@/assets/images/userAvate.png" alt="用户头像" />
            </div>
            <div
              v-if="msg.content"
              v-html="msg.content"
              :class="[
                'bubble',
                msg.type === 'ai' ? 'ai-bubble' : 'user-bubble',
              ]"
            ></div>
          </div>
        </main>
      </template>

      <!-- 输入区域 -->
      <footer v-show="!showHistory" class="footer">
        <div class="footer_top">
          <textarea
            class="input-box"
            v-model="userInput"
            @keydown.enter.prevent="handleSend"
            placeholder="此处回答问题"
            @input="autoResize"
          >
          </textarea>
          <div class="btn-retry">
            <!-- 操作按钮组 -->
            <div class="btn-group-box">
              <div v-if="totalQuestions!=currentQuestion&&doYouAnswer" class="btn-next" @click="nextQuestion">下一题</div>
              <div v-if="showRetry" class="btn-begin" @click="resetQuiz">
                重新作答
              </div>
            </div>
            <div class="btn-send" @click="handleSend">
              <img src="@/assets/images/send.png" alt="" />
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bookName: "", // 当前教材名称
      currentQuestion: 1, // 当前题目编号
      totalQuestions: 0, // 题目总数
      customerId: "", // 用户唯一标识
      chatList: [
        {
          content:
            "您好，欢迎您使用AI智疑功能，我是您的专属AI训练老师kiki，接下来开始我们的练习吧！",
          timestamp: Date.now(),
          type: "ai",
        },
      ], // 聊天记录
      chatHistory: [], //历史记录
      userInput: "", // 用户输入内容
      showHistory: false, // 是否显示历史记录
      showRetry: false, // 是否显示重试按钮
      loading: false,
      doYouAnswer: false, //是否已回答当前题目
    };
  },

  mounted() {
    this.initializeUser();
  },

  methods: {
    autoResize(e) {
      // const textarea = e.target;
      // textarea.style.height = "auto"; // 重置高度
      // textarea.style.height = `${textarea.scrollHeight}px`; // 根据内容设置高度
    },
    /**
     * 初始化用户信息
     * 1. 从sessionStorage获取或生成新用户ID
     * 2. 获取历史答题记录
     */
    initializeUser() {
      this.bookName = this.$route.query.bookName || "";
      this.customerId =
        this.$route.query.userId ||
        sessionStorage.getItem("customerId") ||
        `user_${Date.now()}`;
      sessionStorage.setItem("customerId", this.customerId);
      this.fetchTotalQuestions();
      this.fetchQuestion(1);
    },

    /**
     * 获取历史答题记录（API调用）
     * @param {Object} params - 查询参数
     *   book: 教材名称
     *   start_time: 开始时间
     *   end_time: 结束时间
     *   limit: 返回条数
     */
    async fetchHistory(params = {}) {
      this.loading = true;
      try {
        const url = new URL(
          `https://xiaozhi.kuntai-tech.cn/user_answer_history/${this.customerId}`
        );

        // 设置查询参数
        const queryParams = {
          book: params.book || this.bookName,
          start_time: params.start_time || "",
          end_time: params.end_time || "",
          limit: params.limit || 100,
        };

        url.search = new URLSearchParams(queryParams).toString();

        const res = await fetch(url);
        const data = await res.json();
        let list = data.history || [];
        // 数组倒序
        list.reverse();
        // 转换数据结构：每条记录转换为AI提问 + 用户回答
        this.chatHistory = list.flatMap((record, index) => [
          {
            type: "time",
            content: "",
            timestamp: this.formatTime(record.timestamp, list, index),
          },
          {
            type: "ai",
            content: marked.parse(record.question?.replace(/\\n/g, "<br/>")||''),
            timestamp: "",
          },
          {
            type: "user",
            content: record.user_answer,
            timestamp: "",
          },
          {
            type: "ai",
            content: marked.parse(record.ai_response?.replace(/\\n/g, "<br/>")||''),
            timestamp: "",
          },
        ]);
        setTimeout(() => {
          this.scrollToBottom();
          this.loading = false;
        }, 1000);
      } catch (error) {
        console.error("获取历史记录失败:", error);
        this.chatHistory = [];
        this.loading = false;
      }
    },

    /**
     * 获取题目总数
     */
    async fetchTotalQuestions() {
      try {
        const res = await fetch(
          `https://xiaozhi.kuntai-tech.cn/questions/${this.bookName}`
        );
        const data = await res.json();
        this.totalQuestions = data.total_questions;
      } catch (error) {
        console.error("获取题目总数失败:", error);
      }
    },

    // 下一题
    nextQuestion() {
      if (!this.doYouAnswer) {
        this.$message.error("请先回答当前问题！");
        return;
      }
      if (this.totalQuestions > this.currentQuestion) {
        this.doYouAnswer = false;
        this.currentQuestion++;
        this.fetchQuestion(this.currentQuestion);
      }
    },

    /**
     * 获取指定题目
     * @param {Number} questionNumber - 题目编号
     */
    async fetchQuestion(questionNumber) {
      try {
        const res = await fetch(
          "https://xiaozhi.kuntai-tech.cn/questionnaire",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              book: this.bookName,
              question_number: questionNumber,
              customer_id: this.customerId,
            }),
          }
        );

        const data = await res.json();
        this.addMessage("ai", data.question,'question');
        this.scrollToBottom();
      } catch (error) {
        this.addMessage("ai", "获取题目失败，请稍后重试",'question');
      }
    },

    /**
     * 处理消息发送
     */
    handleSend() {
      const answer = this.userInput.trim();
      if (answer) {
        this.addMessage("user", answer,'answer');
        this.submitAnswer(answer);
        this.userInput = "";
      }
    },

    /**
     * 添加新消息到聊天记录
     * @param {String} type - 消息类型（ai/user）
     * @param {String} content - 消息内容
     */
    addMessage(type, content,contentType) {
      const message = {
        type,
        content: marked.parse(content?.replace(/\\n/g, "<br/>")||''),
        timestamp: Date.now(),
        question:this.currentQuestion,
        contentType,
      };
      this.chatList.push(message);
      this.$nextTick(this.scrollToBottom);
    },

    /**
     * 提交用户答案并获取解析
     * @param {String} answer - 用户答案
     */
    async submitAnswer(answer) {
      let userNumber = 1
      let analysisNumber = 1
      let history=''
      this.chatList.map((item)=>{
        if(item.question===this.currentQuestion&&item.contentType!='question'){
          if(item.contentType=='analysis'){
            history+=`评论 ${analysisNumber}: ${item.content}。`
          }else if(item.contentType=='answer'){
            history+=`学生回答 ${userNumber}: ${item.content}。`
          }
        }
      })
      try {
        const response = await fetch(
          "https://xiaozhi.kuntai-tech.cn/questionnaire",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              book: this.bookName,
              question_number: this.currentQuestion,
              user_answer: answer,
              customer_id: this.customerId,
              history:history
            }),
          }
        );

        // 添加解析占位消息
        this.addMessage("ai", "解析中...",'analysis');
        const analysisIndex = this.chatList.length - 1;

        // 流式处理解析结果
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let analysis = "";

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          const chunk = decoder.decode(value);
          chunk.split("\n").forEach((line) => {
            if (line.startsWith("data: ")) {
              const jsonStr = line?.replace("data: ", "");
              if (jsonStr.startsWith("[DONE]:")) {
                // 处理完成元数据
                const meta = JSON.parse(jsonStr?.replace("[DONE]:", ""));
                this.handleMetaInfo(meta);
              } else {
                // 累加解析内容
                const data = JSON.parse(jsonStr);
                analysis += data.content?.replace(/\\n/g, "<br/>");
                this.$set(this.chatList, analysisIndex, {
                  ...this.chatList[analysisIndex],
                  content: marked.parse(analysis||''),
                });
                this.scrollToBottom();
              }
            }
          });
        }
      } catch (error) {
        // console.error('提交失败:', error);
        // this.$set(this.chatList, analysisIndex, {
        //   ...this.chatList[analysisIndex],
        //   content: '解析失败，请稍后再试'
        // });
      }
    },

    handleMetaInfo(meta) {
      this.doYouAnswer = true;
      if (this.totalQuestions == meta.question_number) {
        this.showRetry = true;
      }
    },

    toggleHistory() {
      this.showHistory = !this.showHistory;
      if (!this.showHistory) {
        this.$nextTick(this.scrollToBottom);
      } else {
        this.fetchHistory();
      }
    },
    resetQuiz() {
      this.chatList = [];
      this.showRetry = false;
      this.currentQuestion = 1;
      this.doYouAnswer = false;
      this.fetchQuestion(1);
    },
    scrollToBottom() {
      const chatArea = this.$el.querySelector(".chat-area");
      if (chatArea) {
        chatArea.scrollTop = chatArea.scrollHeight;
      }
    },
    formatTime(timestamp, list, index) {
      if (index == 0) {
        return new Date(timestamp).toLocaleString();
      } else {
        let currentTime = new Date(timestamp).getTime();
        let lastTime = new Date(list[index - 1].timestamp).getTime();
        if (currentTime - lastTime > 300000) {
          return new Date(timestamp).toLocaleString();
        }
        return "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  background: #f2f2f2;
  padding: 12px 10px;
  min-height: 100vh;
}
.container_box {
  // width: calc(100% * 10 / 14);
  max-width: 800px;
  height: calc(100vh - 24px);
  border-radius: 20px;
  background: #ffffff;
  padding: 14px 16px 0px 20px;
  margin: 0 auto;
}
/* 顶部模块 */
.header {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
  .header_box {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    padding: 0px 7px 0px 0px;
    background-color: #e9f5ff;
    border-radius: 5px;
    color: #6c91ff;
    img {
      width: 22px;
      margin-right: 3px;
    }
  }

  // padding: 12px 16px;
  // border-bottom: 1px solid #eee;
}
.history-btn {
  font-size: 14px;
  color: #999;
  background: none;
  border: 0;
  float: right;
  cursor: pointer;
}
.history-btn:hover {
  color: #666;
  text-decoration: underline;
}

/* 聊天区域 */
.chat-area {
  flex: 1;
  // overflow-y: auto;
  // padding: 12px 16px;
  height: calc(100% - 246px);
  overflow-y: auto;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  .avateAi {
    width: 36px;
    transform: translateY(-20px);
  }
  .userAvate {
    width: 36px;
  }
}

.show-history {
  position: relative;
  height: calc(100% - 50px);
}
.show-history-loading::after {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  content: "加载中...";
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  // 加载中样式
  animation: loading 1s infinite;
}
/* 消息气泡通用样式 */
.message {
  width: 100%;
  display: flex;
  gap: 4px;
  user-select: text !important;
    
}
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
}
.bubble {
  padding: 12px 10px 16px 10px;
  border-radius: 8px;
  font-family: MicrosoftYaHei;
  font-size: 14px;

  line-height: 1.5;
  color: #333;
}
.timestamp {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #777;
}
/* AI消息 */
.ai-message {
  align-self: flex-start;
}
.ai-bubble {
  max-width: calc(100% - 150px);
  background-image: linear-gradient(
    90deg,
    #e3e4ff 0%,
    #e0eeff 65%,
    #ddf7ff 100%
  );
}
/* 用户消息 */
.user-message {
  align-self: flex-end;
  flex-direction: row-reverse;
  gap: 20px;
}
.user-bubble {
  max-width: calc(100% - 150px);
  // background-color: #fffefd;
  background: linear-gradient(white, white) padding-box,
    /* 内层背景（纯色）*/ linear-gradient(to right, #e3e4ff, #e0eeff, #ddf7ff)
      border-box; /* 外层渐变 */
  border: 3px solid transparent; /* 边框宽度 */
  border-radius: 8px; /* 圆角生效 */
  // border-image-source: linear-gradient(90deg,
  // 	#e3e4ff 0%,
  // 	#e0eeff 65%,
  // 	#ddf7ff 100%);
}

/* 底部操作栏 */
.footer {
  width: 100%;
  // padding: 1px;
  padding-top: 40px;

  // border-top: 1px solid #eee;
  // display: flex;
  // gap: 8px;
  .footer_top {
    display: flex;
    // justify-content: space-between;
    flex-direction: column;
    align-items: flex-end;
    // width: 100%;
    // justify-content: space-between;
    min-height: 130px;
    // flex: 7;
    border: 1px solid #c9c9c9;
    border-radius: 12px;
    padding: 16px 12px 0px 16px;
    background: #f2f2f2;
    .btn-retry{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 10px 0;
      
    }
  }
  .btn-send {
    position: relative;
    width: 30px;
    height: 30px;
    background-color: #d1d4df;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      width: 18px;
    }
    &:hover {
      opacity: 0.8;
      background-color: #88a2ff;
    }
  }
  .btn-send::after{
    content: "";
    position: absolute;
    left: - 10px;
    top: 0;
    width: 1px;
    height: 30px;
    background-color: #c9c9c9;
  }
}
.input-box {
  resize: none; /* 禁止手动调整 */
  height: 80px; /* 初始高度 */
  overflow-y: auto; /* 内容超出时显示滚动条 */
  width: 100%;
  // flex: 1;
  resize: none;
  // min-height: 50px;
  font-size: 14px;
  border: 0px;

  background: #f2f2f2;
}
.input-box:focus {
  outline: none;
  border-color: #999;
}
.btn-group-box {
  display: flex;
  align-items: flex-end;
  gap: 12px;

  .btn-next {
    width: 90px;
    height: 30px;
    background-color: #e0ecff;
    border-radius: 20px;

    color: #4b58ed;
    line-height: 30px;
    text-align: center;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .btn-begin {
    width: 90px;
    height: 30px;
    background-image: linear-gradient(
      90deg,
      #787eff 0%,
      #5ea8ff 65%,
      #44d1ff 100%
    );
    border-radius: 20px;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
.btn {
  flex: 1;
  height: 36px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.btn-next {
  background: #007bff;
  color: white;
}
.btn-retry {
  // background: #ffc107;
  // color: #333;
}
/* 新增发送按钮样式 */
.btn-send {
  background: #007bff;
  color: white;
  width: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.send-icon {
  width: 24px;
  height: 24px;
  transition: transform 0.2s;
}
.btn-send:hover .send-icon {
  transform: scale(1.1);
}
.btn-send:active .send-icon {
  transform: scale(0.9);
}

/* 调整输入框间距 */
.input-box {
  // margin-right: 4px;
  /* 其他原有样式保持不变 */
}
</style>

<style lang="scss">
.chat-area{
  .message{
  * {
      user-select: text;
    }
}
}

</style>
